$(document).ready(function () {
    if($('.obfcm .info-inner.invalid').length) {
        $('html, body').animate({
            scrollTop: $("#obfcm-formular").offset().top - 80
        }, 600);
    }
});